module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kC793"))).then(() => parcelRequire('dJXJK'));